module.exports = __webpack_public_path__ + "assets1779866876160/img/lan5.01bd8a8d.png";